<template>
    <div class="form-group">
        <label for="direccionFiscal">Seleccionar dirección fiscal:</label>
        <ValidationProvider name="direccionFiscal" rules="required" mode="passive" v-slot="{ errors }">
            <multiselect 
                v-model="data.direccionFiscal" 
                :options="direccionesFiscales" 
                placeholder="Seleccionar dirección fiscal" 
                label="nombre" 
                track-by="id"
                @input="$emit('direccionFiscal', $event)"
                :disabled="disabled"
            >
                <template slot="noOptions">No hay ninguna dirección fiscal creada</template>
            </multiselect>
            <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            direccionesFiscales: []
        }
    },
    methods: {
        getDireccionesFiscales() {
            const params = {
                filters: {}
            };

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.direcciones.fiscales.index'), params)
                .then(res => {
                    this.direccionesFiscales = res.data.data.filter(res => res.teatro_company_id);

                    if (this.direccionesFiscales.length === 1 && !this.data.direccionFiscal) {
                        this.data.direccionFiscal = this.direccionesFiscales[0];
                        this.$emit('direccionFiscal', this.direccionesFiscales[0]);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    created() {
        this.getDireccionesFiscales();
    }
}
</script>